import $ from "jquery";

document.querySelectorAll('[data-product-list-mode]').forEach(btn => {
    btn.addEventListener("click",
        () => {
            let toMode = btn.dataset.productListMode;
            document.cookie = `BR_ProductListMode=${toMode};max-age-in-seconds=${60 * 60 * 24 * 365}`;
            location.reload();
        });
});

$(".toggleCategoryList").click(function () {
    $(".category-list .dropdown-content").toggle();
    $(this).find("i").toggleClass("bi-chevron-down bi-chevron-up");
    $(this).toggleClass("text-primary");
});
